import React from "react";
import { useForm } from "react-hook-form";
import { Col } from "antd";

import { stepperFormValidationMapper, i18, trb } from "@utilities";
import { STEP_2_VALIDATIONS } from "../../Validations/step2";
import useFormStepControl from "@hooks/useFormStepControl";
import { StepperFormRow } from "@components";
import { ActionButtons } from "../../Components";
import { ClientPlanServices } from "./groups/ClientPlanServices";
import { CompanyFunds } from "./groups/CompanyFunds";

const customCompanyFundsValidation = values => {
  const atleastOneFieldChecked = Object.values(values.companyFunds[0].data || {}).filter(v => v)
    .length;
  if (!atleastOneFieldChecked) {
    return {
      companyFunds: [
        {
          data: {
            other: { message: trb(i18.Validations.FieldsRequired), type: "oneFieldRequired" }
          }
        }
      ]
    };
  }
  return {};
};

export const FormStep2 = () => {
  const {
    formDraft,
    submitForm,
    isSent,
    handleActionButtonClick,
    submitType,
    validateForm
  } = useFormStepControl();

  const { handleSubmit, control, setValue } = useForm({
    resolver: (values, context) =>
      validateForm(values, context, () => {
        const { errors } = stepperFormValidationMapper(values, STEP_2_VALIDATIONS);
        const companyFundsError = customCompanyFundsValidation(values);
        return { values, errors: { ...errors, ...companyFundsError } };
      }),
    context: {
      submitType
    },
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: formDraft.personData
  });

  const onSubmit = data => {
    submitForm(data, submitType);
  };

  const handleOtherCheckboxChange = () => {
    setValue("companyFunds.0.data.otherInput", "", { shouldValidate: true });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <StepperFormRow>
        <Col xs={24} lg={12}>
          <ClientPlanServices control={control} />
        </Col>
        <Col xs={24} lg={12}>
          <CompanyFunds control={control} handleOtherCheckboxChange={handleOtherCheckboxChange} />
        </Col>
      </StepperFormRow>
      <ActionButtons
        isLoading={isSent}
        handlePrevStep={handleActionButtonClick}
        handleNextStep={handleActionButtonClick}
      />
    </form>
  );
};
